exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".petit-size[data-v-8fb65326]{font-size:1em;font-weight:700}thead[data-v-8fb65326]{background-color:#78b943}thead th[data-v-8fb65326],thead th i[data-v-8fb65326]{color:#fff!important}.theme--light.v-subheader[data-v-8fb65326]{font-size:1.3em;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8fb65326","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/events/edit-3.vue
// module id = 87lK
// module chunks = 1